<template>
    <SearchTitle data-testid="initial-search-title">{{ resultCountTitle }} {{ location }}</SearchTitle>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useTranslation, useGlobalMatching} from '#imports';
    import SearchTitle from './SearchTitle.vue';
    import {useProfilesStore} from '../../stores/profiles.store';
    import {isGeoLocationParams, useSearchUrlStore} from '../../stores/search-url.store';

    const {t} = useTranslation();

    const {initialSearchResponse} = storeToRefs(useProfilesStore());
    const searchUrlStore = useSearchUrlStore();
    const {searchUrlParams} = storeToRefs(searchUrlStore);

    const MAX_NB_RESULTS = 300;

    const {isBrowsingGlobalMatching} = useGlobalMatching();

    const resultCountTitle = computed(() =>
        t('search.header.icu.title', {
            cappedNbResults: Math.min(initialSearchResponse.value?.pagination.totalElements ?? 0, MAX_NB_RESULTS),
            jobLabel: searchUrlParams.value.query,
        }),
    );

    const location = computed(() => {
        if (
            !isBrowsingGlobalMatching.value &&
            searchUrlParams.value.locationDetails &&
            isGeoLocationParams(searchUrlParams.value.locationDetails) &&
            searchUrlParams.value.locationDetails.city
        ) {
            return t('search.header.title.location', [searchUrlParams.value.locationDetails.city]);
        }
        return undefined;
    });
</script>
